// FILE: src/services/tiktok.js
import axiosServices from "./axios";

export const getTikTokCreatorInfo = async (platformId) => {
  if (!platformId) {
    throw new Error("platformId is required to fetch TikTok creator info.");
  }

  try {
    const response = await axiosServices.post("/tiktok/creator-info", {
      platform_id: platformId,
    });

    return response.data?.creatorInfo || null;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch TikTok creator info.";

    const normalizedError = new Error(message);
    normalizedError.reauthRequired =
      error.response?.data?.reauthRequired ||
      error.response?.status === 409 ||
      false;
    normalizedError.status = error.response?.status;
    normalizedError.data = error.response?.data;

    throw normalizedError;
  }
};

const tiktokService = {
  getTikTokCreatorInfo,
};

export default tiktokService;